import React from 'react';
import style from './users.module.scss';
import { Container } from '../../../components/content';
import { Card } from 'antd';
import PropTypes from 'prop-types';

const ContentLayout = ({ header, children }) => {
  return (
    <Container className={style.users}>
      <Card className="card-gradient">
        {header && (
          <div className="card-gradient-wrapper">
            {typeof header === 'string' ? (
              <h1 className="text-2xl font-bold">{header}</h1>
            ) : (
              header
            )}
          </div>
        )}
        <div>{children}</div>
      </Card>
    </Container>
  );
};

ContentLayout.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
};

export default ContentLayout;
